import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
//import { FormDataService } from '../../../Services/Form Data /form-data.service';
import { BlobOptions } from 'buffer';
import { FormDataService } from '../../../Services/Form Data/form-data.service';
import { ChangeDetectorRef } from '@angular/core';
import { DataService } from '../../../Services/Data Service/data.service';
import { AuthService } from '../../../Auth/auth.service';
import { firstValueFrom, forkJoin, switchMap, take } from 'rxjs';
import { FormUpdateService } from '../../../Services/Form Data/formupdate.service';
import { FormSubmitService } from '../../../Services/Form Data/formsubmit.service';
import { DisableAutocompleteDirective } from '../../../disable-autocomplete.directive';

@Component({
  selector: 'app-e-top-customers',
  standalone: true,
  imports: [NgFor, FormsModule, NgIf, NgClass, DisableAutocompleteDirective],
  templateUrl: './e-top-customers.component.html',
  styleUrl: './e-top-customers.component.css'
})
export class ETopCustomersComponent {
  @Input() isViewOnly: boolean = false;
  @Input() formData: any; 
  
  error_message = '';

  customers: any;

  subcontract= false; //push to form data
  works: string[] = [];

  blnContractStatus = true;
  strContractDetails = '';

  loading = false;
  currUser: any;
  savedMessage = '';
  exists = false;

  constructor(
    private formDataService: FormDataService, 
    private cdr: ChangeDetectorRef, private dataService: DataService, 
    private auth: AuthService, private formUpdateService: FormUpdateService,
    private formSubmitService: FormSubmitService,
  ) {
  }

  ngOnInit(): void {
    this.subcontract = this.formDataService.getDoesSubcontract();

    const loadedWorks = this.formDataService.getPrimaryWorks(); 
    this.works = loadedWorks ? [...loadedWorks] : [];
  
    this.blnContractStatus = this.formDataService.getblnContractStatus();
    this.strContractDetails = this.formDataService.getstrContractDetails();
    this.currUser = this.formDataService.getUserData();

    const customersData = this.formDataService.getTopCustomers();
    this.customers = (!customersData || customersData.length === 0)
    ? Array(3).fill(null).map(() => ({
        strPastCustomer: '',
        dteYear: '',
        strContractValue: '',
        strContactPerson: '',
        strContactNumber: '',
        strContactEmail: ''
      }))
    : customersData.map((customer: { strContractValue: any; }) => ({
        ...customer,
        strContractValue: customer.strContractValue ?? ''
      }));

    // console.log('Top Customers:', this.customers);
    console.log('primary works oninit: ', this.works);
  }
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes['formData']){
      if (this.formData?.topcustomers) {
        this.customers = this.formData.topcustomers;
      }
    }
  }

  ranges: string[] = [
    '< TTD 10,000',
    'TTD 10,000 - 49,999',
    'TTD 50,000 - 199,999',
    'TTD 200,000 - 999,999',
    'TTD 1,000,000+'
  ];  

  updateWork(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;
    this.works[index] = input.value;
  }

  removeCustomer(index: number): void {
    this.customers[index].strContractValue = '';
  }  
    
  addRow() {
    this.works.push('');
    console.log("Primary works: ", this.works);
  }

  trackByFn(index: number, item: string) {
    return index; // Tracks items by their index to prevent re-renders
  }

  trackByIndex(index: number, item: any): any {
    return index;
  }

  removeRow(index: number) {
    this.works.splice(index, 1); 
  }


  resetErrorMessage(){
    this.error_message = '';
  }


  validatefields(): boolean {
    console.log("Customers: ", this.customers);
    const currentYear = new Date().getFullYear();


    if (this.subcontract && (this.works.length === 0 || this.works[0].trim() === '')) {
      this.error_message = "Enter at least one primary work."; 
      return false;
    }

    if (!this.blnContractStatus && !this.strContractDetails) {
      this.error_message = "Enter details for contracts being incomplete."; 
      return false;
    }

    if (!this.customers || !this.customers[0].strPastCustomer) {
      this.error_message = "Enter at least one customer."; 
      return false;
    }

    for (let i = 0; i < this.customers.length; i++) {
      const customer = this.customers[i];
      if (customer.strPastCustomer) {
        // Validate year
        if (
          !customer.dteYear || 
          customer.dteYear < currentYear - 3 || 
          customer.dteYear > currentYear
        ) {
          this.error_message = `Invalid year for customer ${i + 1}. Year must be within the past 3 years.`;
          return false;
        }

        if (!customer.strContractValue || !customer.strContactPerson || !customer.strContactNumber || !customer.strContactEmail) {
          this.error_message = `All fields must be filled out for customer ${i + 1}.`;
          return false;
        }
      }
    }
    
    return true;
  }


  validatePhoneNumber(input: string, index: number): void {
    // Remove all spaces
    const formattedInput = input.replace(/\s+/g, '');
  
    // Regular expression to match area code (3 digits) + 7 digits = 10 digits total
    const phonePattern = /^\d{10}$/;
  
    // Only validate if at least strPastCustomer is filled
    const customer = this.customers[index];
      if (!customer || !customer.strPastCustomer?.trim()) {
      return;
    }

    if (!phonePattern.test(formattedInput)) {
      this.error_message = "Phone number must be 10 digits (area code + 7 digits).";
      return;
    }
  
    this.error_message = "";
  }

  validateEmail(email: string, index: number): void | boolean{
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = emailPattern.test(email);

      // Only validate if at least strPastCustomer is filled
    const customer = this.customers[index];
    if (!customer || !customer.strPastCustomer?.trim()) {
      return;
    }

    if (!isValid) {
      this.error_message = "Invalid email format. Please enter a valid email.";
    } else {
      this.error_message = "";
    }
}


  async onSubmit(): Promise<boolean>{
   if (!this.validatefields()) {
     return false; // Validation failed
    }
    if (this.error_message !== "") {
      return false; // Error message present, do not proceed
    }

    this.loading = true;
    this.error_message = "";

    //update formData 
    this.formDataService.updatePrimaryWork(this.works.filter(work => work.trim() !== ''));
    this.formDataService.updateDoesSubcontract(this.subcontract);
    this.formDataService.updateTopCustomers(this.customers);
    this.formDataService.updateblnContractStatus(this.blnContractStatus);
    this.formDataService.updatestrContractDetails(this.strContractDetails);

    //SAVE TO DB
    try {
      this.loading = true;

      const companyId = this.formDataService.getCurrCompanyID();

      const result1 = await firstValueFrom(this.formUpdateService.updateCompanyContracts(companyId));
      console.log('updateCompanyContracts result:', result1);

      const result2 = await firstValueFrom(this.formUpdateService.updateContractDetails(companyId));
      console.log('updateContractDetails result:', result2);

      const result3 = await firstValueFrom(this.formSubmitService.submitSubcontracts(companyId));
      console.log('submitSubcontracts result:', result3);

      this.loading = false;
      return true;

    } catch (error) {
      console.error('SAVE ERROR:', error); // log the whole thing
      this.error_message = "There was an issue saving. Please try again.";
      this.loading = false;
      return false;
    }
    // try {
    //   await firstValueFrom( forkJoin([
    //   this.formUpdateService.updateCompanyContracts(this.formDataService.getCurrCompanyID()), //AKA TOP CUSTOMERS
    //   this.formUpdateService.updateContractDetails(this.formDataService.getCurrCompanyID()),
    //   this.formSubmitService.submitSubcontracts(this.formDataService.getCurrCompanyID())
    // ]) );
    //    this.loading = false;
    //   return true;
    // } catch (error) {
    //   this.error_message = "There was an issue saving. Please try again.";
    //   this.loading = false;
    //   return false;
    // }
  }
}
